// extracted by mini-css-extract-plugin
export default {"wrapper":"DdayProgress_wrapper__lotOl","label":"DdayProgress_label__GQHhY"};